// Module
var code = "<script>let $ctrl</script> <div class=\"flexWrapper__headerPanel\"> <organism-page-header-panel page-header-data=\"$ctrl.pageHeaderData\"></organism-page-header-panel> </div> <organism-managed-project-wizard-wrapper machine=\"$ctrl.machine\" ressource-servers=\"$ctrl.ressourceServers\"></organism-managed-project-wizard-wrapper> ";
// Exports
module.exports = code;